import { Fragment, useState, useCallback, useRef, useEffect } from 'react';
import {
    Accordion, AccordionSummary, AccordionDetails, Backdrop, Button, Box, Checkbox, Collapse, DialogTitle, Dialog, Grow, FormControl, FormControlLabel, InputAdornment, InputLabel, Select, MenuItem, Typography, DialogContent, DialogActions, TextField, createFilterOptions, Card, CardHeader, CardContent, Autocomplete, Tab, Tabs,
    LinearProgress, Divider, Paper, Popover, styled, Slider, Tooltip as MuiTooltip
} from '@mui/material';
import { TransitionGroup } from 'react-transition-group';
import { AttachMoney } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import ReplayIcon from '@mui/icons-material/Replay';
import StarsIcon from '@mui/icons-material/Stars';

import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser } from "../../../redux/reducers/authSlice";
import { AutocompleteElement, FormContainer, MultiSelectElement, SelectElement, TextFieldElement, SliderElement } from 'react-hook-form-mui';
import Grid from "@mui/material/Grid";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteIcon from "@mui/icons-material/Delete";
import VerifiedIcon from '@mui/icons-material/Verified';

import theme from "../../../theme";
import html2pdf from 'html2pdf.js'; // Assuming you have installed the library with npm

import dayjs from "dayjs";
import { removeEmpty } from "../../../lib/utils/index.js";
import * as XLSX from 'xlsx';
import { getConversionesCAC, getIndiceAt, CAC2nominal, getImporteNuevoMes, nominal2CAC, getEstadosHistoricosCDC } from '../../../edilia/index'
import { MinutaContrato } from '../../../edilia/MinutaContrato'
import _ from 'lodash'

import React, { PureComponent } from 'react';
import { ComposedChart, ReferenceLine, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Scatter, ResponsiveContainer, ReferenceArea } from 'recharts';
import './ContratosCat.css';
import ClipLoader from "react-spinners/ClipLoader";
import { motion } from "framer-motion";
import { getContratosData, addContrato, editContrato, deleteContrato } from "./contratosSlice.js";

const CotizadorCat = () => {

    let thread = null;

    if (window.Worker) {

        const workerCode = `
        self.onmessage = function (e) {
        const { data } = e;
        const { funcHistoria, payload } = data;
        //self.postMessage( { funcHistoria, payload })
        eval(funcHistoria)(...payload).then(res => self.postMessage(res));
    };`;
        const blob = new Blob([workerCode], { type: 'application/javascript' });

        thread = ({ funcHistoria, payload }) => new Promise((resolve, reject) => {
            let worker = new Worker(URL.createObjectURL(blob));
            worker.postMessage({ funcHistoria, payload });
            worker.onmessage = function (e) {
                resolve(e.data);
            };

            worker.onerror = function (e) {
                reject(e);
            };
        });
    }

    const MESES_LAG = 2;

    const splitCamelCaseWithAbbreviations = s => s.replace(/([A-Z][a-z]+)|([A-Z]+)/g, ' $1 $2 ').trim();
    const moneyFormat = (v) => "$" + new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v) / 100).replace("ARS", "");
    const getLabel = (option) => {
        if (option.personaFisica) {
            if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
            return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
        } else {
            if (!option.denominacionSocial && !option.cuit) return option.email;
            return option.denominacionSocial + ' - ' + option.cuit;
        }
    };
    function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
    };
    function getFecha(date) {
        date = new Date(parseInt(date)).toLocaleString().split(",");
        date = date[0].split("/");

        let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
        let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
        let y = date[2];
        return d + '/' + m + '/' + y
    };

    // Elimina acentos, mayusculas y simbolos extra;os del string
    const normStr = (str) => str.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const calc = async ({ params, cuotaPactadaNominal, indices, clasesContratos, simAdjudicacion, canalesAdjudicacion, tiposCampana, funcHistoria }) => {
        const defaultContrato = { vendedorId: null, serie: 1, claseContratoId: '', perPrimaAdjudicacion: 0, referenciadoId: null, adelantoInicialNominal: '', fechaCreacion: Date.now() };
        //A: el contratodefault cuando el usuario esta creando un nuevo contrato
        const getIndiceAt = (fecha = params.fechaCreacion, difMeses = 0) => {
            function fechaNMesesAntes(ts, N) {
                let fecha = new Date(ts);
                fecha.setMonth(fecha.getMonth() + N);
                return fecha;
            };

            if (indices == null) return 1;
            fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
            fecha = fechaNMesesAntes(fecha.getTime(), difMeses);
            return (indices || [])
                .filter(i => {
                    const iFecha = new Date(parseInt(i.fecha));
                    return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
                }).sort((a, b) => a.fecha - b.fecha)[0];
        };
        let fechaCreacion = new Date(params.fechaCreacion);
        const indiceActual = fechaCreacion.getMonth() >= MESES_LAG ?
            getIndiceAt(fechaCreacion.setMonth(fechaCreacion.getMonth() - MESES_LAG)) :
            getIndiceAt(fechaCreacion.setMonth(fechaCreacion.getMonth() + (12 - MESES_LAG)) && fechaCreacion.setFullYear(fechaCreacion.getFullYear() - 1));
        // let contrato = (contratos || [])?.find(c => c.contratoId === row.contratoId);
        const nom2Nom = (nom, fechaA, fechaB) => nom * getIndiceAt(fechaB, -2)?.cac / getIndiceAt(fechaA, -2)?.cac;
        const nominal2CAC = (nom, fecha) => nom / indiceActual?.cac;
        const CAC2Nominal = (cac, fecha) => cac * indiceActual?.cac;

        const indice = getIndiceAt(params.fechaCreacion, -2);
        const claseCochera = clasesContratos?.find(cc => cc.codigo === 'COCH-STD-QI');
        const claseBaulera = clasesContratos?.find(cc => cc.codigo === 'BAUL-STD-QI');
        const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === params.claseContratoId);
        const nextMonth = (ts) => {
            let old = new Date(typeof ts === 'string' ? parseInt(ts) : ts);
            let date = old.getMonth() === 11 ? `${1}/1/${old.getFullYear() + 1}` : `${old.getMonth() + 2}/1/${old.getFullYear()}`;
            return parseInt((new Date(date)).valueOf() + 18000000); //Arregla la dif de horario entre arg y utc
        };
        const getAdelantoRecurrenteNom = () => {
            //Valor del bien
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            let prima = (1 - params.perPrimaAdjudicacion);
            let adelantoConBonif = nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
            let factorRefuerzo = (params.refuerzo ? 350 : 300)
            let cuotaMinCAC = (((valorOASum * prima) - adelantoConBonif) / factorRefuerzo)
            //let cuotaMin =  CAC2Nominal(cuotaMinCAC, params.fechaCreacion) / 100
            let cuotaMin = CAC2Nominal(((valorOASum * prima) - nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)) / factorRefuerzo, params.fechaCreacion) / 100
            const adelanto = cuotaPactadaNominal - cuotaMin;

            // const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            // let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            // valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            // valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            // const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            // const adelanto = cuotaPactadaNominal - CAC2Nominal(factor * valorOACAC, params.fechaCreacion) / 100;
            return adelanto < 0 ? 0 : adelanto;
        };
        const getBonificacionInicial = () => {
            const bonifIniCAC = nominal2CAC(params?.adelantoInicialNominal * 100 * claseContrato?.perBonificiacionAdelantoInicial, params.fechaCreacion);
            return getConversionesCAC(bonifIniCAC, indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
        };
        const bonificacionMensual = () => {
            const cuota = nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion);

            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;

            const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            let bonif = params.perPrimaAdjudicacion > 0 ? 0 : getConversionesCAC((cuota - factor * valorOACAC) * claseContrato?.perBonificiacionAdelantoRecurrente, indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
            return bonif
        };
        const aporteMensualReconocido = () => {
            const cuota = nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion);
            const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);

            return getConversionesCAC(cuota + (cuota - factor * valorOACAC) * (params.perPrimaAdjudicacion > 0 ? 0 : claseContrato?.perBonificiacionAdelantoRecurrente), indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
        };
        const indicesSim = [];
        const pagosSim = [];
        let ultimaFecha = new Date(params.fechaCreacion);
        let res = [];
        let fechaAdjudicacion = null;
        let fechaEntrega = null;

        const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
        let valorOATotalCAC = claseContrato?.valorObjetoAhorroCAC;
        valorOATotalCAC += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
        valorOATotalCAC += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
        const valorOACAC = valorOATotalCAC - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
        const cuotaMin = CAC2Nominal(factor * valorOACAC, params.fechaCreacion) / 100;
        const contratoDfltValues = {
            perPrimaAdjudicacion: params.perPrimaAdjudicacion,
            mesRefuerzoSemestral1: params.refuerzo ? 5 : null,
            mesRefuerzoSemestral2: params.refuerzo ? 11 : null,
            fechaCreacion: new Date(params.fechaCreacion).valueOf(),
            fechaFirma: new Date(params.fechaCreacion).valueOf(),
            fechaPerfeccionamiento: new Date(params.fechaCreacion).valueOf(),
            referenciadoId: 1,
            cuponDePagoMensualCuotas: null,
            fechaAplicacionDesde: 1671803885672,
            fechaAplicacionHasta: null,
        };

        const contratos = [{
            ...contratoDfltValues,
            action: 'INSERT',
            contratoId: 1,
            id: 1,
            claseContratoId: claseContrato?.claseContratoId,
            adelantoInicialNominal: params?.adelantoInicialNominal * 100 * claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC,
            adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom(), params.fechaCreacion) * claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC,
            contratoPrincipalId: null,
            fechaEdicion: params.fechaCreacion,
        }];
        if (params.cochera) contratos.push({
            ...contratoDfltValues,
            contratoId: 2,
            id: 2,
            claseContratoId: claseCochera.claseContratoId,
            adelantoInicialNominal: params.adelantoInicialNominal * 100 * claseCochera?.valorBienCAC / valorOATotalCAC,
            adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom(), params.fechaCreacion) * claseCochera?.valorObjetoAhorroCAC / valorOATotalCAC,
            contratoPrincipalId: 1,
        });
        if (params.baulera) contratos.push({
            ...contratoDfltValues,
            contratoId: 3,
            id: 3,
            claseContratoId: claseBaulera.claseContratoId,
            adelantoInicialNominal: params.adelantoInicialNominal * 100 * claseBaulera?.valorBienCAC / valorOATotalCAC,
            adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom(), params.fechaCreacion) * claseBaulera?.valorObjetoAhorroCAC / valorOATotalCAC,
            contratoPrincipalId: 1,
        });
        for (let i = 0; i < 800; i++) {
            indicesSim.push({ fecha: ultimaFecha - 86400000 * 400, cac: parseInt(getIndiceAt(params.fechaCreacion, -MESES_LAG)?.cac) });
            ultimaFecha = nextMonth(ultimaFecha);
        };

        ultimaFecha = params.fechaCreacion;
        pagosSim.push({ fecha: ultimaFecha + 1, montoNominal: (params.adelantoInicialNominal * 100) * (claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC), contratoId: 1 });

        for (let i = 0; i < 301; i++) {
            const mesN = i % 12;
            const { mesRefuerzoSemestral1, mesRefuerzoSemestral2 } = contratos[0];
           if (i < params.mesAdjudicacion || !simAdjudicacion) {
                pagosSim.push({ fecha: ultimaFecha + 2, montoNominal: (cuotaPactadaNominal * 100 * claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC), contratoId: 1, });
                if (mesN === mesRefuerzoSemestral1 || mesN === mesRefuerzoSemestral2)
                    pagosSim.push({ fecha: ultimaFecha + 2, montoNominal: (cuotaPactadaNominal * 100 * claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC), contratoId: 1, });
            } else if (i <= params.mesAdjudicacion + params.mesesEntrega && simAdjudicacion) {
                pagosSim.push({ fecha: ultimaFecha + 2, montoNominal: ((cuotaPactadaNominal * 100) * (claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC)), contratoId: 1, });
                if (mesN === mesRefuerzoSemestral1 || mesN === mesRefuerzoSemestral2)
                    pagosSim.push({ fecha: ultimaFecha + 2, montoNominal: ((cuotaPactadaNominal * 100) * (claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC)), contratoId: 1, });

                if (i === params.mesAdjudicacion) fechaAdjudicacion = ultimaFecha;
                if (i === params.mesAdjudicacion + params.mesesEntrega) fechaEntrega = ultimaFecha;

                if (i === params.mesAdjudicacion && params.tipoAdjudicacion === 'Dineraria') {
                    //console.log('Dineraria', params.ofertaDineraria * 100 / 1.05)
                    pagosSim.push({ fecha: ultimaFecha + 3, montoNominal: params.ofertaDineraria * 100 / 1.05, contratoId: 1, });
                }
                if ((i >= params.mesAdjudicacion && i < params.mesAdjudicacion + params.mesesEntrega)) {
                    //console.log('Cuota Prima', (CAC2Nominal(claseContrato?.valorObjetoAhorroCAC * params.perPrimaAdjudicacion, Date.now())) / 24)

                    pagosSim.push({ fecha: ultimaFecha + 3, montoNominal: (CAC2Nominal(claseContrato?.valorObjetoAhorroCAC * params.perPrimaAdjudicacion, Date.now())) / 24, contratoId: 1, });
                }
            } else if (i > params.mesAdjudicacion + params.mesesEntrega && simAdjudicacion) {
                if (i >= params.mesAdjudicacion + params.mesesEntrega) {
                    const factor = params.refuerzo ? 1.7 : 1.6;
                    const cuotaPos = cuotaMin * factor * 100;
                    //console.log('Cuota Posesion', cuotaPos)
                    pagosSim.push({ fecha: ultimaFecha + 4, montoNominal: cuotaPos, contratoId: 1, });

                    if (mesN === mesRefuerzoSemestral1 || mesN === mesRefuerzoSemestral2)
                        pagosSim.push({ fecha: ultimaFecha + 2, montoNominal: ((cuotaPactadaNominal * 100) * (claseContrato?.valorObjetoAhorroCAC / valorOATotalCAC)), contratoId: 1, });
                }
            }

            ultimaFecha = nextMonth(ultimaFecha);
        };
        const context = {
            CDCContratos: contratos,
            clasesContratos,
            eventosAdjudicacion: [{
                eventoAdjudicacionID: 1,
                fechaEvento: fechaAdjudicacion - 100,
                fechaAnuncio: fechaAdjudicacion - 200,
                fechaCreacion: fechaAdjudicacion - 300,
                fechaInicioLicitacionDineraria: fechaAdjudicacion - 200,
                fechaFinalizacionLicitacionDineraria: fechaAdjudicacion - 100
            }],
            adjudicaciones: [1, 2, 3].map((x, i) => ({
                adjudicacionId: i + 1,
                canalId: canalesAdjudicacion.find(x => x.nombreCanal === params.tipoAdjudicacion).canalId,
                eventoAdjudicacionId: 1,
                departamentoId: i + 1,
                fechaAdjudicacion: fechaAdjudicacion,
                contratoId: i + 1,
            })),
            ofertasDinerarias: [],
            //titularidades: [{partes: 100, titularidadContratosId: 1, contratoId: 1, personaId: 1}],
            titularidades: [],
            CDCTitularidades: [],
            canalesAdjudicacion,
            edificios: [{ edificioId: 1, calle: '', altura: 1234, cantidadPisos: 12, }],
            departamentos: [
                { departamentoId: 1, claseContratoId: claseContrato.claseContratoId, m2: claseContrato.m2, piso: 1, uniFuncional: 1, edificioId: 1 },
                { departamentoId: 2, claseContratoId: claseCochera.claseContratoId, m2: claseContrato.m2, piso: 1, uniFuncional: 2, edificioId: 1 },
                { departamentoId: 3, claseContratoId: claseBaulera.claseContratoId, m2: claseContrato.m2, piso: 1, uniFuncional: 3, edificioId: 1 },
            ],
            entregasUnidades: [
                { departamentoId: 1, fecha: fechaEntrega },
                { departamentoId: 2, fecha: fechaEntrega },
                { departamentoId: 3, fecha: fechaEntrega },
            ],
            intencionesPago: [],
            campanas: [],
            tiposCampanas: tiposCampana,
            pagos: pagosSim,
            indices: indicesSim,
        };

        if (funcHistoria && clasesContratos && context.CDCContratos && ultimaFecha) {

            if (thread) {
                res = await thread({
                    funcHistoria,
                    payload: [
                        clasesContratos,
                        context,
                        MESES_LAG,
                        getEstadosHistoricosCDC(context.CDCContratos.filter(x => 1 === parseInt(x.contratoId))),
                        ultimaFecha]
                })
            } else {
                const foo = eval(funcHistoria);
                res = await foo(1, context, MESES_LAG, getEstadosHistoricosCDC(context.CDCContratos.filter(x => 1 === parseInt(x.contratoId))), ultimaFecha);
            }

        };
        return res;

    };
    function debounce(func, wait) {

        let timeout;
        function executedFunction(...args) {
            let a = Date.now();
            const later = () => {
                console.log('debounce')
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };

        return executedFunction;
    };
    const calcDebounced = debounce(({ params, cuotaPactadaNominal, indices, clasesContratos, simAdjudicacion, canalesAdjudicacion, tiposCampana, funcHistoria, setPlotData }) => {

        calc({ params, cuotaPactadaNominal, indices, clasesContratos, simAdjudicacion, canalesAdjudicacion, tiposCampana, funcHistoria }).then(res => {
           // console.log('RES', res)
            const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === params.claseContratoId);
            const primerPago = res?.filter(x => x.operacion.tipo === 'Pago')[0];
            const valorCAC = primerPago?.estado?.adelantoInicialAcumCAC + primerPago?.estado?.adelantoInicialBonifAcumCAC + primerPago?.estado?.ofertaLicitatoriaAcumCAC
                + primerPago?.estado?.ofertaLicitatoriaBonifAcumCAC + primerPago?.estado?.cuotaEsperaAcumCAC + primerPago?.estado?.cuotaEsperaBonifAcumCAC
                + primerPago?.estado?.primaAcumCAC + primerPago?.estado?.cuotaPrimaBonifAcumCAC + primerPago?.estado?.cuotaPosesionAcumCAC
                + primerPago?.estado?.adelantoRecurrenteAcumCAC + primerPago?.estado?.adelantoRecurrenteBonifAcumCAC + primerPago?.estado?.adelantoEspontaneoAcumCAC
                + primerPago?.estado?.adelantoEspontaneoBonifAcumCAC + primerPago?.estado?.refuerzoSemestralCuotaEsperaAcumCAC + primerPago?.estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
                + primerPago?.estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + primerPago?.estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC
            let maxCap = 0;
            console.log('c-valorCAC', valorCAC)
            let ga = valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1
            let pData = [{
                i: 0,
                GA: valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1,
                primaRestante: primerPago?.estado?.primaRestanteCAC / claseContrato?.valorObjetoAhorroCAC,
                capLicitatorio: primerPago?.estado?.capitalLicitatorioCAC / claseContrato?.valorObjetoAhorroCAC,
                adjudicacion: (0 === params.mesAdjudicacion ? (valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1) : null),
                entrega: (0 === (params.mesAdjudicacion + params.mesesEntrega) ? (valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1) : null),
            },
            ...res.filter(x => x.operacion.tipo === 'Nuevo Mes').map((x, i) => {
                const valorCAC = x.estado?.adelantoInicialAcumCAC + x.estado?.adelantoInicialBonifAcumCAC + x.estado?.ofertaLicitatoriaAcumCAC
                    + x.estado?.ofertaLicitatoriaBonifAcumCAC + x.estado?.cuotaEsperaAcumCAC + x.estado?.cuotaEsperaBonifAcumCAC
                    + x.estado?.primaAcumCAC + x.estado?.cuotaPrimaBonifAcumCAC + x.estado?.cuotaPosesionAcumCAC
                    + x.estado?.adelantoRecurrenteAcumCAC + x.estado?.adelantoRecurrenteBonifAcumCAC + x.estado?.adelantoEspontaneoAcumCAC
                    + x.estado?.adelantoEspontaneoBonifAcumCAC + x.estado?.refuerzoSemestralCuotaEsperaAcumCAC + x.estado?.refuerzoSemestralCuotaEsperaBonifAcumCAC
                    + x.estado?.refuerzoSemestralAdelantoRecurrenteAcumCAC + x.estado?.refuerzoSemestralAdelantoRecurrenteBonifAcumCAC
                ga += (x.estado.moraCAC + valorCAC) / claseContrato?.valorObjetoAhorroCAC
                // const finalizo = ga / claseContrato?.valorObjetoAhorroCAC > 1;
                const finalizo = valorCAC / claseContrato?.valorObjetoAhorroCAC > 1;
                maxCap = (((i > params.mesAdjudicacion && simAdjudicacion) || finalizo) ? maxCap : x.estado.capitalLicitatorioCAC / claseContrato?.valorObjetoAhorroCAC);
                return {
                    i: i + 1,
                    GA: finalizo ? 1 : valorCAC / claseContrato?.valorObjetoAhorroCAC,
                    primaRestante: x.estado.primaRestanteCAC / claseContrato?.valorObjetoAhorroCAC,
                    capLicitatorio: maxCap,
                    adjudicacion: (i === params.mesAdjudicacion ? (valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1) : null),
                    entrega: (i === (params.mesAdjudicacion + params.mesesEntrega) ? (valorCAC / claseContrato?.valorObjetoAhorroCAC <= 1 ? valorCAC / claseContrato?.valorObjetoAhorroCAC : 1) : null),
                }
            })];
            setPlotData(pData)
        })
    }, 500);

    const currentUser = useSelector(selectCurrentUser);
    const dispatch = useDispatch();
    const fetching = useSelector(state => state.contratos.fetching);
    const { clasesContratos, personas, rolesPersonasMap, roles, indices, tiposCampana, funcHistoria } = useSelector(state => state.contratos.data);
    useEffect(() => { dispatch(getContratosData()) }, []);

    //-------------FORM PARA EDITAR CONTRATO

    const getIndiceAt = (fecha = new Date(), difMeses = 0) => {
        function fechaNMesesAntes(ts, N) {
            let fecha = new Date(ts);
            fecha.setMonth(fecha.getMonth() + N);
            return fecha;
        };

        if (indices == null) return 1;
        fecha = new Date(typeof fecha === 'string' ? parseInt(fecha) : fecha);
        fecha = fechaNMesesAntes(fecha.getTime(), difMeses);
        return (indices || [])
            .filter(i => {
                const iFecha = new Date(parseInt(i.fecha));
                return iFecha.getFullYear() === fecha.getFullYear() && iFecha.getMonth() === fecha.getMonth();
            }).sort((a, b) => a.fecha - b.fecha)[0];
    };
    const PopupIcon = (props) => {
        const [anchorEl, setAnchorEl] = useState(null);

        const handlePopoverOpen = (event) => {
            setAnchorEl(event.currentTarget)
        };

        const handlePopoverClose = () => {
            setAnchorEl(null)
        };
        const { label, key, Icon } = props;
        const open = Boolean(anchorEl);
        return (
            <Fragment key={key + label}>
                <Icon aria-owns={open ? label : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}> </Icon>
                <Popover
                    id={label}
                    sx={{
                        pointerEvents: 'none',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                >
                    <Typography sx={{ p: 1 }}>{label}</Typography>
                </Popover>
            </Fragment>
        )
    };
    const ContratoForm = ({ contratoOriginal, cocheraOriginal, bauleraOriginal }) => {
        const scale = 1;
        const [loadingMinuta, setLoadingMinuta] = useState(false);
        const TIPOS_DNI = {
            "dni": "DNI",
            "pasaporte": "Pasaporte",
            "libreta_enrolamiento": "Libreta de Enrolamiento",
            "libreta_civica": "Libreta Cívica",
        };
        const [socios, setSocios] = useState([]); //A: aca guardamos los socios, son una lista separada
        const [newSocios, setNewSocios] = useState([]);
        let formDflts = { juridica: false, fechaInicioVigencia: Date.now(), fechaAplicacionDesde: Date.now(), titularPrincipal: newSocios.concat(socios)?.length === 0 ? true : false, porcentaje: 100, nombre: '', apellido: '', email: '', rolesIds: [10], tipoDocumento: '', numeroDocumento: '', cuil: '', cuit: '', pais: '', provincia: '', telefono1: '', ciudad: '', codigoPostal: '' };
        let formDfltsJuridica = { juridica: true, fechaInicioVigencia: Date.now(), fechaAplicacionDesde: Date.now(), titularPrincipal: newSocios.concat(socios)?.length === 0 ? true : false, porcentaje: 100, denominacionSocial: '', rolesIds: [10], nombreFantasia: '', tipoSocietario: '', numeroInscripcionRegistral: '', email: '', telefono1: '', cuit: '', pais: '', provincia: '', ciudad: '', personaFisica: false, codigoPostal: '' };
        const [errores, setErrores] = useState([])
        const getDropdownOptions = (allPersonas) => {
            let personasAsArray = (personas || []).filter(p => p.personaFisica && !p.eliminado);
            if (!allPersonas) {
                personasAsArray = personasAsArray.filter(p => p.personaFisica && !p.eliminado);
            }
            return personasAsArray.map(p => ({ id: p.personaId, label: getLabel(p) }));
        };
        const getDropdownAhorristas = (allPersonas) => {
            let personasAhorristasIds = (rolesPersonasMap || [])?.filter(pr => pr.rolId === (roles || [])?.find(r => r.nombre === 'Ahorrista')?.rolId)?.map(pr => pr.personaId)
            let personasAhorristas = allPersonas?.filter(p => personasAhorristasIds?.includes(p.id))
            return personasAhorristas
        };
        const getDropdownVendedores = (allPersonas) => {
            let personasVendedoresIds = (rolesPersonasMap || [])?.filter(pr => pr.rolId === (roles || [])?.find(r => r.nombre === 'Ejecutivo de Cuentas')?.rolId ||
                pr.rolId === (roles || [])?.find(r => r.nombre === 'Vendedor Externo')?.rolId)?.map(pr => pr.personaId)
            let personasVendedores = allPersonas?.filter(p => personasVendedoresIds?.includes(p.id))
            return personasVendedores
        };
        const [params, setParams] = useState({
            cochera: false,
            baulera: false,
            claseContratoId: 1,
            perPrimaAdjudicacion: 0.00,
            adelantoInicialNominal: 0.00,
            refuerzo: false,
            fechaCreacion: new Date().valueOf(),
            fechaFirma: (new Date()).setHours(0, 0, 0, 0),
            //fechaPerfeccionamiento: Date.now(),
            tipoAdjudicacion: 'Sorteo',
            ofertaDineraria: 0.00,
            mesAdjudicacion: 240,
            mesesEntrega: 24,
            vendedorId: null,
            referenciadoId: null,
            serie: 1,
            fechaAplicacionDesde: (new Date()).setHours(0, 0, 0, 0),

        });
        const filterOptions = createFilterOptions({ matchFrom: 'any', limit: 500, });
        const nom2Nom = (nom, fechaA, fechaB) => nom * getIndiceAt(fechaB, -2)?.cac / getIndiceAt(fechaA, -2)?.cac;
        const nominal2CAC = (nom, fecha) => nom / getIndiceAt(fecha, -2)?.cac;
        const CAC2Nominal = (montoCac, fecha) => montoCac * getIndiceAt(fecha, -2)?.cac;
        const handleChange = useCallback(debounce((property, value) => setParams({ ...params, [property]: value })));
        const canalesAdjudicacion = ['Sorteo', 'Puntos', 'Dineraria', 'Extraordinaria'].map((x, i) => ({ canalId: i + 1, nombreCanal: x, descripcion: x }));
        const [cuotaPactadaNominal, setCuotaPactadaNominal] = useState(0)
        const [campanas, setCampanas] = useState({ campana1: false, campana2: new Date(params?.fechaCreacion).getDate() > 19 ? false : true, campanaPAE: { campanaPAE: false, porcentaje: 20, fechaFinalizacion: new Date().getDate(params?.fechaCreacion) > 19 ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 4) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 3), fechaInicio: new Date(params?.fechaCreacion).getDate() > 19 ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 2) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 1) } })
        const [stepForm, setStepForm] = useState(0);
        const [msjFooter, setMsjFooter] = useState([]);
        const [simAdjudicacion, setSimAdjudicacion] = useState(false);
        const [claseAspiracionalId, setClaseAspiracionalId] = useState(1);

        const [plotData, setPlotData] = useState([]);
        const indice = getIndiceAt(params.fechaCreacion, -2);
        const claseCochera = clasesContratos?.find(cc => cc.codigo === 'COCH-STD-QI');
        const claseBaulera = clasesContratos?.find(cc => cc.codigo === 'BAUL-STD-QI');
        const claseContrato = clasesContratos?.find(cc => cc.claseContratoId === params.claseContratoId);
        const generatePDF = async (id) => {
            setLoadingMinuta(true); // Activate the loading indicator
            try {
                const element = document.getElementById(id);
                const options = {
                    margin: [0, 60, 0, 0], // Set your margin value
                    filename: 'Minuta_Comercial.pdf',
                    image: { type: 'jpeg', quality: 1 },
                    html2canvas: {
                        dpi: 192,
                        scale: 6,
                        letterRendering: true,
                        useCORS: true
                    },
                    jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
                };

                const pdf = await html2pdf().from(element).set(options).save();

                // Use the generated PDF as needed
                // Example: download the PDF
                // pdf.save();
            } catch (error) {
                console.error(error);
                // Handle errors if necessary
            } finally {
                setLoadingMinuta(false); // Deactivate the loading indicator, regardless of the result
            }
        };
        useEffect(() => {
            //Valor del bien
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            let prima = (1 - params.perPrimaAdjudicacion);
            let adelantoConBonif = nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
            let factorRefuerzo = (params.refuerzo ? 350 : 300);
            let cuotaMin = CAC2Nominal(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, params.fechaCreacion) / 100

            // const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            // let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            // valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            // valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            // const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            // const cuotaMin = CAC2Nominal(factor * valorOACAC, params.fechaCreacion) / 100;
            if (cuotaPactadaNominal < cuotaMin) setCuotaPactadaNominal((cuotaMin).toFixed(2));
        }, [params]);


        // Handle Submit
        const handleSubmit = (form) => {
            setMsjFooter([]);
            let huboError = false
            let sociosTotales = newSocios.concat(socios)
            if (Math.abs(sociosTotales.reduce((p, x) => p + parseFloat(x.porcentaje), 0) - 100) > 0.0001) {
                huboError = true
                setMsjFooter([...msjFooter, `Los porcentajes de titularidad deben sumar 100%!`]);
                return
            };
            newSocios.forEach(s => {
                if (s.juridica) {
                    if (s.denominacionSocial.length === 0) {
                        huboError = true
                        setMsjFooter([...msjFooter, `El campo "Denominación Social" es obligatorio.`]);
                        return
                    };
                    if (s.nombreFantasia.length === 0) {
                        huboError = true
                        setMsjFooter([...msjFooter, `El campo "Nombre Fantisía" es obligatorio.`]);
                        return
                    };
                } else {
                    if (s.nombre.length === 0) {
                        huboError = true
                        setMsjFooter([...msjFooter, `El campo "Nombre" es obligatorio.`]);
                        return
                    };
                    if (s.apellido.length === 0) {
                        huboError = true
                        setMsjFooter([...msjFooter, `El campo "Apellido" es obligatorio.`]);
                        return
                    };
                }
                if (s.email.length === 0) {
                    huboError = true
                    setMsjFooter([...msjFooter, `El campo "Email" es obligatorio.`]);
                    return
                };
                if (s.cuit.length === 0) {
                    huboError = true
                    setMsjFooter([...msjFooter, `El campo "CUIT" es obligatorio.`]);
                    return
                };
                if (s.telefono1.length === 0) {
                    huboError = true
                    setMsjFooter([...msjFooter, `El campo "Telefono" es obligatorio.`]);
                    return
                };
            })
            if (huboError) {
                return
            };
            generatePDF("minuta-comercial")
                .then(() => {
                    // El PDF se ha generado con éxito
                    //console.log('PDF generado con éxito');
                })
                .catch((error) => {
                    // Ocurrió un error al generar el PDF
                    console.error('Error al generar el PDF:', error);
                });
            sociosTotales.forEach(s => delete s.juridica)
            let totalValor = claseContrato?.valorObjetoAhorroCAC
            totalValor += (params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0)
            totalValor += (params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0)

            let perDpto = claseContrato?.valorObjetoAhorroCAC / totalValor
            let perCochera = params.cochera ? claseCochera?.valorObjetoAhorroCAC / totalValor : 0
            let perBaulera = params.baulera ? claseBaulera?.valorObjetoAhorroCAC / totalValor : 0

            const contratoDpto = {
                serie: params?.serie,
                claseContratoId: params?.claseContratoId,
                vendedorId: params?.vendedorId?.id,
                referenciadoId: params?.referenciadoId?.id,
                perPrimaAdjudicacion: params?.perPrimaAdjudicacion,
                fechaCreacion: params?.fechaCreacion,
                adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom() * 100, params?.fechaCreacion) * perDpto,
                adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * perDpto) * 100).toFixed(0)),
                mesRefuerzoSemestral1: params?.refuerzo ? 0 : null,
                mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                fechaAplicacionDesde: params?.fechaCreacion,
                socios: sociosTotales,
                subContratos: [],
                campanas: []
            };
            let subContratos = []
            if (params?.cochera || params?.baulera) {
                const contratoCochera = {
                    serie: params?.serie,
                    vendedorId: params?.vendedorId?.id,
                    referenciadoId: params?.referenciadoId?.id,
                    perPrimaAdjudicacion: params?.perPrimaAdjudicacion,
                    fechaCreacion: params?.fechaCreacion,
                    adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom() * 100, params?.fechaCreacion) * perCochera,
                    adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * perCochera) * 100).toFixed(0)),
                    claseContratoId: claseCochera?.claseContratoId,
                    contratoPrincipalId: null,
                    mesRefuerzoSemestral1: params?.refuerzo ? 0 : null,
                    mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                    fechaAplicacionDesde: params?.fechaCreacion,
                };
                const contratoBaulera = {
                    serie: params?.serie,
                    vendedorId: params?.vendedorId?.id,
                    referenciadoId: params?.referenciadoId?.id,
                    perPrimaAdjudicacion: params?.perPrimaAdjudicacion,
                    fechaCreacion: params?.fechaCreacion,
                    adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom() * 100, params?.fechaCreacion) * perBaulera,
                    adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * perBaulera) * 100).toFixed(0)),
                    claseContratoId: claseBaulera?.claseContratoId,
                    contratoPrincipalId: null,
                    mesRefuerzoSemestral1: params?.refuerzo ? 0 : null,
                    mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                    fechaAplicacionDesde: params?.fechaCreacion,
                };
                subContratos = params?.cochera ? [...subContratos, { ...contratoCochera }] : subContratos
                subContratos = params?.baulera ? [...subContratos, { ...contratoBaulera }] : subContratos
            }
            let campanasSubmit = []
            const campana1 = {
                contratoId: null,
                tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Refuerzo Ahorro')?.tipoCampanaId,
                fechaInicio: new Date(params?.fechaCreacion).setHours(0, 0, 0, 0),
                fechaFinalizacion: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setMonth(fecha.getMonth() + 4);
                    fecha.setMonth(fecha.getMonth() + 1, 0);
                    fecha.setHours(23, 59, 0, 0);
                    return fecha.valueOf();
                })(),
                parametros: { porcentaje: 0 },
                creacion: true
            };
            const campana2 = {
                contratoId: null,
                tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Cuota Ahorro')?.tipoCampanaId,
                fechaInicio: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setDate(1);
                    fecha.setMonth(fecha.getMonth() + 1);
                    fecha.setHours(0, 0, 0, 0);
                    return fecha.valueOf();
                })(),
                fechaFinalizacion: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setMonth(fecha.getMonth() + 1);
                    fecha.setMonth(fecha.getMonth() + 1, 0);
                    fecha.setHours(23, 59, 0, 0);
                    return fecha.valueOf();
                })(),
                parametros: { porcentaje: 0 },
                creacion: true
            };
            const campana3 = {
                contratoId: null,
                tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Adelanto Prepactado')?.tipoCampanaId,
                fechaInicio: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setDate(1);
                    fecha.setMonth(fecha.getMonth() + 1);
                    fecha.setHours(0, 0, 0, 0);
                    return fecha.valueOf();
                })(),
                fechaFinalizacion: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setMonth(fecha.getMonth() + 1);
                    fecha.setMonth(fecha.getMonth() + 1, 0);
                    fecha.setHours(23, 59, 0, 0);
                    return fecha.valueOf();
                })(),
                parametros: { porcentaje: 0 },
                creacion: true
            }
            const campanaPAE = {
                contratoId: null,
                tipoCampanaId: tiposCampana?.find(t => t.nombre === 'Per Bonificación Cuota PAE')?.tipoCampanaId,
                fechaInicio: (() => {
                    const fecha = new Date(parseInt(params?.fechaCreacion));
                    fecha.setDate(1);
                    fecha.setMonth(fecha.getMonth() + !campanas?.campana2 ? 2 : 1);
                    fecha.setHours(0, 0, 0, 0);
                    return fecha.valueOf();
                })(),
                fechaFinalizacion: (() => {
                    const fecha = new Date(parseInt(campanas?.campanaPAE?.fechaFinalizacion));
                    fecha.setMonth(fecha.getMonth() + 1, 0);
                    fecha.setHours(23, 59, 0, 0);
                    return fecha.valueOf();
                })(),
                parametros: { porcentaje: (campanas?.campanaPAE?.porcentaje / 100) },
                creacion: true
            }
            campanasSubmit = campanas?.campana1 ? [...campanasSubmit, { ...campana1 }] : campanasSubmit
            campanasSubmit = !campanas?.campana2 ? [...campanasSubmit, { ...campana2 }, { ...campana3 }] : campanasSubmit
            campanasSubmit = campanas?.campanaPAE.campanaPAE ? [...campanasSubmit, { ...campanaPAE }] : campanasSubmit
            removeEmpty(contratoDpto);
            contratoDpto.subContratos = subContratos
            contratoDpto.campanas = campanasSubmit
            dispatch(addContrato([contratoDpto]))
                .catch(err => { setMsjFooter([...msjFooter, 'No fue posible cargar el contrato: ' + claseContrato?.descripcion + '.']); huboError = true });
        };
        // Fulciones Step 2 Formulario
        const removeSocio = (index) => setSocios([...socios.filter((x, i) => i !== index)]);
        const removeNewSocio = (index) => setNewSocios([...newSocios.filter((x, i) => i !== index)]);
        const handelSocioChange = (socio, index) => {
            let newSocios = [...socios];
            if (newSocios[index] === null || newSocios[index] === undefined) newSocios[index] = {};
            newSocios[index].socio = socio;
            newSocios[index].socioId = socio.id;
            setSocios(newSocios);
        };

        // Fulciones Step 1 Formulario
        const handleMouseDownInput = (event) => {
            event.preventDefault();
        };
        const getAdelantoRecurrenteNom = () => {
            //Valor del bien
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            let prima = (1 - params.perPrimaAdjudicacion);
            let adelantoConBonif = nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
            let factorRefuerzo = (params.refuerzo ? 350 : 300)
            let cuotaMinCAC = (((valorOASum * prima) - adelantoConBonif) / factorRefuerzo)
            //let cuotaMin =  CAC2Nominal(cuotaMinCAC, params.fechaCreacion) / 100
            let cuotaMin = CAC2Nominal(((valorOASum * prima) - nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)) / factorRefuerzo, params.fechaCreacion) / 100
            const adelanto = cuotaPactadaNominal - cuotaMin;

            // const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            // let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            // valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            // valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            // const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            // const adelanto = cuotaPactadaNominal - CAC2Nominal(factor * valorOACAC, params.fechaCreacion) / 100;
            return adelanto < 0 ? 0 : adelanto;
        };
        const getBonificacionInicial = () => {
            const bonifIniCAC = nominal2CAC(params?.adelantoInicialNominal * 100 * claseContrato?.perBonificiacionAdelantoInicial, params?.fechaCreacion);
            return getConversionesCAC(bonifIniCAC, indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
        };
        const bonificacionMensual = () => {
            const cuota = nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion);

            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;

            const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            let bonif = params.perPrimaAdjudicacion > 0 ? 0 : getConversionesCAC((cuota - factor * valorOACAC) * claseContrato?.perBonificiacionAdelantoRecurrente, indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
            return bonif
        };
        const aporteMensualReconocido = () => {
            const cuota = nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion);
            const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);

            return getConversionesCAC(cuota + (cuota - factor * valorOACAC) * (params.perPrimaAdjudicacion > 0 ? 0 : claseContrato?.perBonificiacionAdelantoRecurrente), indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
        };
        const getCuotaPAE = () => {
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            let m2EqSum = claseContrato?.m2Eq;
            m2EqSum += params.cochera ? claseCochera?.m2Eq : 0;
            m2EqSum += params.baulera ? claseBaulera?.m2Eq : 0;
            let claseContatoConsolidada = { ...claseContrato, valorObjetoAhorroCAC: valorOASum, m2Eq: m2EqSum };
            let cuotaPAE = getConversionesCAC((valorOASum / claseContrato?.nCuotas), indice, claseContatoConsolidada, params.fechaCreacion, params.fechaCreacion);
            return cuotaPAE
        };
        useEffect(() => { calcDebounced({ params, cuotaPactadaNominal, indices, clasesContratos, simAdjudicacion, canalesAdjudicacion, tiposCampana, funcHistoria, setPlotData }) }, [params, cuotaPactadaNominal, simAdjudicacion])

        //Minuta
        const MinutaTabCotizador = props => {
            function getMesAnio(mes, anio) {
                switch (parseInt(mes)) {
                    case 1:
                        mes = "ene";
                        break;
                    case 2:
                        mes = "feb";
                        break;
                    case 3:
                        mes = "mar";
                        break;
                    case 4:
                        mes = "abr";
                        break;
                    case 5:
                        mes = "may";
                        break;
                    case 6:
                        mes = "jun";
                        break;
                    case 7:
                        mes = "jul";
                        break;
                    case 8:
                        mes = "ago";
                        break;
                    case 9:
                        mes = "sep";
                        break;
                    case 10:
                        mes = "oct";
                        break;
                    case 11:
                        mes = "nov";
                        break;
                    default:
                        mes = "dic";
                        break;
                }
                return mes + '-' + anio
            };
            const [claseContratoConsolidada, setClaseContratoConsolidada] = useState({
                valorObjetoAhorroCAC: claseContrato?.valorObjetoAhorroCAC +
                    (params?.cochera ? claseCochera?.valorObjetoAhorroCAC : 0) +
                    (params?.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0),
                nCuotas: claseContrato?.nCuotas,
                mesRefuerzoSemestral1: params?.refuerzo ? 1 : null,
                mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                perCuotaPosesion: claseContrato?.perCuotaPosesion,
                perBonificiacionAdelantoRecurrente: claseContrato?.perBonificiacionAdelantoRecurrente,
                perBonificiacionAdelantoInicial: claseContrato?.perBonificiacionAdelantoInicial,
                principal: claseContrato?.principal,
                m2Eq: claseContrato?.m2Eq +
                    (params?.cochera ? claseCochera.m2Eq : 0) +
                    (params?.baulera ? claseBaulera.m2Eq : 0)
            });
            const [estado, setEstado] = useState({
                adelantoInicialRestanteCAC: params ? (parseFloat(parseInt((params?.adelantoInicialNominal * 100).toFixed(0))) / parseFloat(indice?.cac)) : null,
                cuotaEsperaMesRestanteCAC: claseContratoConsolidada ?
                    ((claseContratoConsolidada?.valorObjetoAhorroCAC * (1 - params.perPrimaAdjudicacion))
                        - (nominal2CAC(params?.adelantoInicialNominal * 100, params.fechaCreacion))
                        * (1 + claseContratoConsolidada?.perBonificiacionAdelantoInicial))
                    / (params?.refuerzo ? 350 : 300) : null,
                indice: { ...indice }
            });
            // MINUTA COMERCIAL CONSOLIDADA
            useEffect(() => {
                let newEstado = {
                    adelantoInicialRestanteCAC: params ? (parseFloat((params?.adelantoInicialNominal * 100)) / parseFloat(indice?.cac)) : null,
                    cuotaEsperaMesRestanteCAC: (nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion)),
                    indice: { ...indice }
                };
                let newClase = {
                    valorObjetoAhorroCAC: claseContrato?.valorObjetoAhorroCAC +
                        (params?.cochera ? claseCochera?.valorObjetoAhorroCAC : 0) +
                        (params?.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0),
                    nCuotas: claseContrato?.nCuotas,
                    perCuotaPosesion: claseContrato?.perCuotaPosesion,
                    perBonificiacionAdelantoRecurrente: claseContrato?.perBonificiacionAdelantoRecurrente,
                    perBonificiacionAdelantoInicial: claseContrato?.perBonificiacionAdelantoInicial,
                    m2Eq: claseContrato?.m2Eq +
                        (params?.cochera ? claseCochera.m2Eq : 0) +
                        (params?.baulera ? claseBaulera.m2Eq : 0)
                };
                setEstado(newEstado);
                setClaseContratoConsolidada(newClase);
            }, [params]);
            let titularesSocios = socios?.length === 0 ? [] : socios?.map(s => {
                let persona = (personas || [])?.find(persona => persona.personaId === s.socioId)
                return ({ ...persona, porcentaje: s.porcentaje, titularPrincipal: s.titularPrincipal })
            });
            let titulares = titularesSocios?.concat(newSocios)
            // MINUTA POR PRODUCTO
            // Porcentaje por producto
            let totalValor = claseContrato?.valorObjetoAhorroCAC
            totalValor += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0
            totalValor += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0

            let perDpto = claseContrato?.valorObjetoAhorroCAC / totalValor
            let perCochera = params.cochera ? claseCochera?.valorObjetoAhorroCAC / totalValor : 0
            let perBaulera = params.baulera ? claseBaulera?.valorObjetoAhorroCAC / totalValor : 0
            //Dpto
            const contratoDpto = {
                ...params,
                adelantoRecurrenteCAC: (getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, params.fechaCreacion), indice, claseContratoConsolidada)?.cac) * perDpto,
                adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * 100) * perDpto).toFixed(0)),
                mesRefuerzoSemestral1: params?.refuerzo ? 1 : null,
                mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
            };
            //Cochera
            const contratoCochera = {
                ...params,
                adelantoRecurrenteCAC: (getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, params.fechaCreacion), indice, claseContratoConsolidada)?.cac) * perCochera,
                adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * 100) * perCochera).toFixed(0)),
                mesRefuerzoSemestral1: params?.refuerzo ? 1 : null,
                mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                perPrimaAdjudicacion: params.cochera ? params?.perPrimaAdjudicacion : 0.00
            }
            //Baulera
            const contratoBaulera = {
                ...params,
                adelantoRecurrenteCAC: (getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100, params.fechaCreacion), indice, claseContratoConsolidada)?.cac) * perBaulera,
                adelantoInicialNominal: parseInt(((params?.adelantoInicialNominal * 100) * perBaulera).toFixed(0)),
                mesRefuerzoSemestral1: params?.refuerzo ? 1 : null,
                mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                perPrimaAdjudicacion: params.baulera ? params?.perPrimaAdjudicacion : 0.00
            };
            return (
                <>
                    <MinutaContrato
                        contrato={params ? {
                            ...params,
                            mesRefuerzoSemestral1: params?.refuerzo ? 0 : null,
                            mesRefuerzoSemestral2: params?.refuerzo ? 6 : null,
                            adelantoRecurrenteCAC: nominal2CAC(getAdelantoRecurrenteNom() * 100, params.fechaCreacion),
                            adelantoInicialNominal: (params?.adelantoInicialNominal * 100),
                            claseAspiracional: clasesContratos?.find(c => c.claseContratoId === claseAspiracionalId)
                        } : {}}
                        claseContrato={claseContrato}
                        claseContratoConsolidada={claseContratoConsolidada}
                        estado={estado}
                        titulares={titulares}
                        segundaHoja={true}
                        contratoDpto={contratoDpto}
                        contratoCochera={contratoCochera}
                        contratoBaulera={contratoBaulera}
                        claseCochera={{ ...claseCochera, valorObjetoAhorroCAC: (params.cochera ? claseCochera?.valorObjetoAhorroCAC : (0)) }}
                        claseBaulera={{ ...claseBaulera, valorObjetoAhorroCAC: (params.baulera ? claseBaulera?.valorObjetoAhorroCAC : (0)) }}
                        MESES_LAG={MESES_LAG}
                        campanaPAEForm={{ ...campanas?.campanaPAE, porcentaje: campanas?.campanaPAE?.porcentaje / 100 }}
                    />
                </>
            )
        };
        const CuotasTable = () => {

            const getPrima = () => {
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                let prima = getConversionesCAC(params.perPrimaAdjudicacion * valorOASum, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
                return prima;
            }
            const getPrimaCuota24 = () => {
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                // let prima = getConversionesCAC(params.perPrimaAdjudicacion * valorOASum, indice, claseContrato, params.fechaCreacion, params.fechaCreacion);
                let cuota = getConversionesCAC((params.perPrimaAdjudicacion * valorOASum) / 24, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
                return cuota;
            }
            const aporteMinimoEnEspera = () => {
                //Valor del bien
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                let prima = (1 - params.perPrimaAdjudicacion);
                let adelantoConBonif = nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
                let factorRefuerzo = (params.refuerzo ? 350 : 300);
                let cuotaMin = CAC2Nominal(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, params.fechaCreacion) / 100

                return getConversionesCAC(((valorOASum * prima) - adelantoConBonif) / factorRefuerzo, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
            }

            const aporteMinimoAdjudicacion = () => {
                const factor = (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
                const cuotaPrima = params.perPrimaAdjudicacion * valorOASum / 24;
                return getConversionesCAC(factor * valorOACAC + cuotaPrima, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
            }

            const aporteMinimoTenencia = () => {
                const factorRefuerzo = params?.refuerzo ? (6 / 7) : 1;
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                const valorOACAC = (valorOASum * (1 - params.perPrimaAdjudicacion)) - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
                const perCuotaPosesion = params.refuerzo ? 1.7 : 1.6;
                const cuotaTenenciaCAC = (valorOACAC / 300 * factorRefuerzo) * perCuotaPosesion
                return getConversionesCAC(cuotaTenenciaCAC, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
            }

            const aguinaldoRefuerzo = () => {
                let valorOASum = claseContrato?.valorObjetoAhorroCAC;
                valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
                valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
                const cuota = nominal2CAC(cuotaPactadaNominal * 100, params.fechaCreacion)
                return getConversionesCAC(params.refuerzo ? cuota : 0, indice, { ...claseContrato, valorObjetoAhorroCAC: valorOASum }, params.fechaCreacion, params.fechaCreacion);
            }

            const GridHeaders = ({ label }) => {
                const GridHeader = props => <Grid fontWeight={600} paddingLeft={'.1em'} item xs={props.xs} backgroundColor={theme.palette.success.main} color='white' children={props.children} />;

                return (<>
                    <GridHeader xs={5.5} children={label} />
                    <GridHeader xs={2} children={`Nominal`} />
                    {/* <GridHeader xs={1.5} children={`CAC`} /> */}
                    <GridHeader xs={2} children={`Cuotas Eq`} />
                    {/* <GridHeader xs={1.5} children={`M2`} /> */}
                    <GridHeader xs={2} children={`GA`} />
                </>)
            };
            const GridRow = ({ label, nominal, cac, cuotasEq, m2, ga }) => {
                const GridHeader = props => <Grid fontWeight={400} paddingLeft={'.1em'} item xs={props.xs} children={props.children} />;
                return (<>
                    <GridHeader xs={5.5} children={label} fontWeight={500} />
                    <GridHeader xs={2} children={moneyFormat((nominal).toFixed(2))} />
                    {/* <GridHeader xs={1.5} children={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((parseFloat(cac)).toFixed(3)).replace("ARS", "")} /> */}
                    <GridHeader xs={2} children={cuotasEq.toFixed(3)} />
                    {/* <GridHeader xs={1.5} children={m2.toFixed(3)} /> */}
                    <GridHeader xs={2} children={`%` + (ga * 100).toFixed(3)} />
                </>)
            };
            return (<Grid style={{ marginLeft: '4rem' }} container fullwidth >
                <GridRow label={<><Typography children={'APORTE DE REFERENCIA EN AHORRO '} /><Typography children={'(CUOTA EQUIVALENTE)'} /></>} {...getCuotaPAE()} />
                <GridHeaders label='' />
                {/* <GridRow label='BONIFICACIÓN INICIAL' {...getBonificacionInicial()} /> */}
                <GridRow label='APORTE MÍNIMO EN AHORRO'  {...aporteMinimoEnEspera()} />
                <GridRow label='PRIMA TOTAL' {...getPrima()} />
                <GridRow label='CUOTA PRIMA ADJUDICACIÓN (24)' {...getPrimaCuota24()} />
                {/* <GridRow label='APORTE MÍNIMO EN ADJUDICACIÓN' {...aporteMinimoAdjudicacion()} /> */}
                <GridRow label='APORTE MÍNIMO EN TENENCIA'  {...aporteMinimoTenencia()} />
                <GridRow label='AGUINALDO - REFUERZO'  {...aguinaldoRefuerzo()} />
                {/* <GridRow label='BONIFICACIÓN MENSUAL'  {...bonificacionMensual()} /> */}
                {/* <GridRow label='APORTE MENSUAL RECONOCIDO' {...aporteMensualReconocido()} /> */}
            </Grid>)
        };
        const ClaseContratoSelector = (props) => {
            const handleChangeClase = (v) => {
                let clase = clasesContratos?.find(c => c.claseContratoId === v)
                if (clase?.principal) handleChange('claseContratoId', v);
                setParams({ ...params, cochera: false, baulera: false, claseContratoId: v })
                setClaseAspiracionalId(v)
            }
            return (<FormControl fullWidth >
                <InputLabel id="seleccion-clase-contrato">Clase Contrato</InputLabel>
                <Select labelId="seleccion-clase-contrato" value={params.claseContratoId} label="Clase Contrato" onChange={e => handleChangeClase(e.target.value)}>
                    {clasesContratos?.map(x => <MenuItem key={x.claseContratoId} value={x.claseContratoId}>{x.codigo}</MenuItem>)}
                </Select>
            </FormControl>)
        };
        const ClaseContratoAspiracionalSelector = (props) => {
            return (<FormControl fullWidth >
                <InputLabel id="seleccion-clase-contrato">Clase Final Proyectada</InputLabel>
                <Select labelId="seleccion-clase-contrato" value={claseAspiracionalId} label="Clase Contrato" onChange={e => setClaseAspiracionalId(e.target.value)}>
                    {clasesContratos?.map(x => <MenuItem key={x.claseContratoId} value={x.claseContratoId}>{x.codigo}</MenuItem>)}
                </Select>
            </FormControl>)
        };
        const TipoAdjudicaciónSelector = (props) => {
            return (<FormControl fullWidth disabled={!simAdjudicacion}>
                <InputLabel id="seleccion-tipo-adjudicacion">Tipo Adjudicación</InputLabel>
                <Select labelId="seleccion-tipo-adjudicacion" value={params.tipoAdjudicacion} label="Tipo Adjudicación" onChange={e => handleChange('tipoAdjudicacion', e.target.value)}>
                    <MenuItem value='Sorteo'>Sorteo</MenuItem>
                    <MenuItem value='Puntos'>Puntos</MenuItem>
                    <MenuItem value='Dineraria'>Dineraria</MenuItem>
                    <MenuItem value='Extraordinaria'>Extraordinaria</MenuItem>
                </Select>
            </FormControl>)
        };
        const getMinCuotaNominal = () => {
            //Valor del bien
            let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            let prima = (1 - params.perPrimaAdjudicacion);
            let adelantoConBonif = nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)
            let factorRefuerzo = (params.refuerzo ? 350 : 300)
            let cuotaMin = CAC2Nominal(((valorOASum * prima) - nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion) * (1 + claseContrato?.perBonificiacionAdelantoInicial)) / factorRefuerzo, params.fechaCreacion) / 100

            // const factor = (1 - params.perPrimaAdjudicacion) * (params.refuerzo ? 1.0 : 7.0 / 6.0) / claseContrato?.nCuotas;
            // let valorOASum = claseContrato?.valorObjetoAhorroCAC;
            // valorOASum += params.cochera ? claseCochera?.valorObjetoAhorroCAC : 0;
            // valorOASum += params.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0;
            // const valorOACAC = valorOASum - (1 + claseContrato?.perBonificiacionAdelantoInicial) * nominal2CAC(params.adelantoInicialNominal * 100, params.fechaCreacion);
            // const cuotaMin = CAC2Nominal(factor * valorOACAC, params.fechaCreacion) / 100;
            return (cuotaMin).toFixed(2)
        };

        //-------------------Modal confirmación
        const handleValidation = () => {
            setMsjFooter([]);
            let huboError = false
            if (stepForm === 0) {
                setMsjFooter([]);
                if (cuotaPactadaNominal < getMinCuotaNominal()) {
                    setMsjFooter([...msjFooter, `La cuota prepactada no podrá ser menor a $${getMinCuotaNominal()}`])
                    huboError = true
                    return;
                }
                if (cuotaPactadaNominal < getMinCuotaNominal()) {
                    setMsjFooter([...msjFooter, `La cuota prepactada no podrá ser menor a $${getMinCuotaNominal()}`])
                    huboError = true
                    return;
                }
                if (campanas.campanaPAE.campanaPAE && (campanas.campanaPAE?.porcentaje > 100 || campanas.campanaPAE?.porcentaje < 0)) {
                    setMsjFooter([...msjFooter, `El porcentaje de la campaña ALTA TEMPRANA no puede ser superior a 100 o menor 0.`])
                    huboError = true
                    return;
                }
                if (huboError) {
                    return
                };
                setStepForm(1)
            } else {
                setMsjFooter([]);
                let sociosTotales = newSocios.concat(socios)
                if (Math.abs(sociosTotales?.reduce((p, x) => p + parseFloat(x.porcentaje), 0) - 100) > 0.0001) {
                    setMsjFooter(msjFooter.includes(`Los porcentajes de titularidad deben sumar 100%!`) ? [...msjFooter] : [...msjFooter, `Los porcentajes de titularidad deben sumar 100%!`]);
                    huboError = true
                    return
                };
                if (!sociosTotales?.find(s => s.titularPrincipal === true)) {
                    setMsjFooter(msjFooter.includes(`Debe seleccionar un titular principal.`) ? [...msjFooter] : [...msjFooter, `Debe seleccionar un titular principal.`]);
                    huboError = true
                    return
                };
                if (sociosTotales?.filter(s => s.titularPrincipal === true)?.length > 1) {
                    setMsjFooter(msjFooter.includes(`Debe seleccionar solo un titular principal.`) ? [...msjFooter] : [...msjFooter, `Debe seleccionar solo un titular principal.`]);
                    huboError = true
                    return
                };
                for (let s of newSocios) {
                    if (s.juridica) {
                        if (s.denominacionSocial.length === 0) {
                            huboError = true
                            setMsjFooter(msjFooter.includes(`El campo "Denominación Social" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "Denominación Social" es obligatorio.`]);
                            break;
                        };
                        if (s.nombreFantasia.length === 0) {
                            huboError = true
                            setMsjFooter(msjFooter.includes(`El campo "Nombre Fantisía" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "Nombre Fantisía" es obligatorio.`]);
                            break;
                        };
                    } else {
                        if (s.nombre.length === 0) {
                            let error = `El campo "Nombre" es obligatorio.`
                            huboError = true
                            setMsjFooter(msjFooter.includes(error) ? [...msjFooter] : [...msjFooter, error]);
                            break;
                        }
                        if (s.apellido.length === 0) {
                            huboError = true
                            setMsjFooter(msjFooter.includes(`El campo "Apellido" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "Apellido" es obligatorio.`]);
                            break;
                        };
                    }
                    if (s.email.length === 0) {
                        huboError = true
                        setMsjFooter(msjFooter.includes(`El campo "Email" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "Email" es obligatorio.`]);
                        break;
                    };
                    if ((personas || []).find(p => p.email.toLowerCase() === s.email.toLowerCase())) {
                        huboError = true
                        setMsjFooter(msjFooter.includes(`El email ${s.email} pertenece a un usuario cargado en el sistema.`) ? [...msjFooter] : [...msjFooter, `El email ${s.email} pertenece a un usuario cargado en el sistema.`]);
                        break;
                    };
                    if (s.cuit.length === 0) {
                        huboError = true
                        setMsjFooter(msjFooter.includes(`El campo "CUIT" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "CUIT" es obligatorio.`]);
                        break;
                    };
                    if (s.telefono1.length === 0) {
                        huboError = true
                        setMsjFooter(msjFooter.includes(`El campo "Telefono" es obligatorio.`) ? [...msjFooter] : [...msjFooter, `El campo "Telefono" es obligatorio.`]);
                        break;
                    };
                    if (s.codigoPostal.length !== 4) {
                        huboError = true
                        setMsjFooter(msjFooter.includes(`El código postal debe ser de 4 dígitos.`) ? [...msjFooter] : [...msjFooter, `El código postal debe ser de 4 dígitos.`]);
                        break;
                    };
                };
                if (huboError) {
                    return
                };
                openModalConfirmacion()
            }
        }
        const [modalConfirmacion, setModalConfirmacion] = useState(false);
        const openModalConfirmacion = () => setModalConfirmacion(true);
        const closeModalConfirmacion = () => setModalConfirmacion(false);
        const ModalConfirmacion = (props) => {
            return (
                <Fragment>
                    <Dialog TransitionComponent={Grow} onClose={closeModalConfirmacion} fullWidth open={modalConfirmacion} maxWidth="sm">
                        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Confirmar</DialogTitle>
                        <DialogContent dividers>
                            {fetching > 0 ?
                                <Grid direction={'column'} sx={{
                                    display: 'flex',
                                    justifyContent: 'center', // Centra horizontalmente
                                    alignItems: 'center', // Centra verticalmente
                                    minHeight: '20vh', // Asegura que el contenedor ocupe toda la altura de la pantalla
                                }}>
                                    <Typography children={'Cargando contrato...'} />
                                    <ClipLoader
                                        color={theme.palette.success.main}
                                        loading={fetching > 0}
                                        size={30}
                                        data-testid="loader"
                                    />
                                </Grid>
                                : <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography>
                                            ¿Seguro quiere crear el contrato? Esta acción no podrá deshacerse.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography>
                                            Ha seleccionado: {claseContrato?.descripcion}.
                                        </Typography>
                                        <Typography>
                                            Cochera: {params?.cochera ? 'Sí' : 'No'}.
                                        </Typography>
                                        <Typography>
                                            Baulera:  {params?.baulera ? 'Sí' : 'No'}.
                                        </Typography>
                                    </Grid>
                                </Grid>
                            }
                        </DialogContent>
                        <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
                            <Button
                                disabled={fetching > 0}
                                variant="outlined"
                                onClick={closeModalConfirmacion}
                                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}>
                                {'Cancelar'}
                            </Button>
                            <Button
                                disabled={fetching > 0}
                                variant="contained"
                                onClick={handleSubmit}
                                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold", color: "white" }}>
                                {'Aceptar'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Fragment>
            );
        };
        const [modalCampPAE, setModalCampPAE] = useState(false);
        const ModalCampPAE = (props) => {
            const [campana, setCampana] = useState({ ...campanas.campanaPAE });
            return (
                <Fragment>
                    <Dialog TransitionComponent={Grow} onClose={() => setModalCampPAE(false)} open={modalCampPAE} maxWidth="sm">
                        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Campaña ALTA TEMPRANA</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2} direction='row' justifyContent={'space-around'} sx={{ marginTop: '0.5vh' }}>
                                <Grid xs={3} children={<TextField sx={{ width: '100%' }}
                                    disabled={!(campanas.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                    value={campana?.porcentaje}
                                    onChange={(e) => { setCampana({ ...campana, porcentaje: e.target.value }) }}
                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                    id="outlined-basic" type='number' label='%' defaultValue={0}
                                    error={campana?.porcentaje > 100 || campana?.porcentaje < 0}
                                />} style={{ padding: '0.5rem' }} />
                                <Grid xs={3} children={<TextField sx={{ width: '100%' }}
                                    disabled={!(campana?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                    value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((CAC2Nominal(getCuotaPAE()?.cac * (campana?.porcentaje / 100), new Date().valueOf())) / 100).replace("ARS", "")}
                                    className='noBorder'
                                    InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                    id="outlined-basic" label='' defaultValue={0}
                                />} style={{ padding: '0.5rem' }} />
                                <Grid xs={3} children={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        disabled={!(campana?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                        label={"Fecha Fin"}
                                        inputFormat="DD/MM/YYYY"
                                        value={(parseInt(campana?.fechaFinalizacion))}
                                        color={"secondary"}
                                        onChange={(v) => { setCampana({ ...campana, fechaFinalizacion: (new Date(v).setHours(23, 59, 0, 0)).valueOf() }) }}
                                        renderInput={(params) => <TextField error={false}{...params} />} /></LocalizationProvider>} style={{ padding: '0.5rem' }} />
                            </Grid>
                        </DialogContent>
                        <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
                            <Button
                                variant="outlined"
                                onClick={() => setModalCampPAE(false)}
                                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}>
                                {'Volver'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => { setCampanas({ ...campanas, campanaPAE: { ...campana } }); setModalCampPAE(false) }}
                                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}>
                                {'Aceptar'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Fragment>
            );
        };
        const CustomTooltip = ({ active, payload, label }) => {
            if (active && payload && payload.length) {
                const i = payload[0].payload.i;

                const FechaHeader = () => {
                    const str = `Año: ${parseInt(i / 12)}, Mes: ${i % 12 + 1}`
                    return (<Typography variant="h6" children={str} component="div" />);
                };

                const GAPara = () => {
                    return <Typography color={theme.palette.info.main} children={`Grado Avance : ${(payload[0].value * 100).toFixed(2)}%`} />
                };

                const PrimaResPara = () => {
                    return <Typography color={theme.palette.warning.main} children={`Prima Restante : ${(payload[1].value * 100).toFixed(2)}%`} />
                };

                const CapLicPara = () => {
                    return <Typography color={theme.palette.success.main} children={`Cap. Licitatorio  : ${(payload[2].value * 100).toFixed(2)}%`} />
                };

                return (
                    <Card>
                        <div style={{ padding: '1em' }}>
                            <FechaHeader />
                            <GAPara />
                            <CapLicPara />
                            <PrimaResPara />
                        </div>
                    </Card>

                );
            }

            return null;
        };
        return (<Box fullWidth style={{ zoom: scale }}>
            <ModalConfirmacion />
            <ModalCampPAE />
            <Grid conteiner sx={{ display: 'flex', alingItems: 'strech', justifyContent: 'space-between' }}>
                <Grid xs={10} children={<Typography variant="h4" fontWeight={700} style={{ backgroundColor: 'white', color: theme.palette.success.main, marginBottom: '0.5em' }}>Alta de Precontrato:</Typography>} />
                <Grid xs={2} children={<Box sx={{ margin: '0.5em', display: 'flex', justifyContent: 'flex-end' }}>
                    {stepForm === 0 ? null : <Button component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="outlined" sx={{ fontWeight: "bold", marginLeft: '1em' }} onClick={e => setStepForm(0)}>{'Volver'}</Button>}
                    <Button component={motion.div} whileHover={{ scale: 1.1, transition: { duration: 0.3 } }} whileTap={{ scale: 0.9 }} variant="contained" sx={{ fontWeight: "bold", marginLeft: '1em' }} onClick={() => stepForm === 0 ? handleValidation() : handleValidation()}>{stepForm === 0 ? 'Siguente' : 'Aceptar'}</Button>
                </Box>} />

            </Grid>

            <Box maxWidth='100%' sx={{ margin: 'auto' }} style={{
                        maxHeight: '100vh', // Ajusta la altura máxima según necesites
                        overflowY: 'auto', // Habilita el desplazamiento vertical
                        //marginRight: '-16px', // Compensa el ancho de la barra de desplazamiento
                        //paddingRight: '16px', // Mantiene el espacio para el contenido, ajusta según el ancho real de la barra de desplazamiento
                        scrollbarWidth: 'none', // Especifico para Firefox
                        '::WebkitScrollbar': {
                            display: 'none' // Especifico para WebKit (Chrome, Safari, etc.)
                        },
                        padding: '8px'
                    }} >
                {/* Cotizador */}
                {stepForm === 0 ?
                    <Fragment >
                        <Grid container spacing={1} fullwidth height={'100vh'} >
                            <Grid item xs={6} children={<Grid container sx={{ paddingRight: '0.5em' }} fullwidth alignItems={'center'}>
                                <Grid xs={12} children={<Typography fontWeight={700} color={theme.palette.success.main} children={`Inicialización de plan de pago:`} />} sx={{ p: '0.5em' }} />
                                <Grid xs={4} children={<ClaseContratoSelector />} sx={{ paddingRight: '.5em' }} />
                                <Grid xs={4} children={<ClaseContratoAspiracionalSelector />} sx={{ paddingRight: '.5em' }} />
                                <Grid xs={4} children={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        fullWidth
                                        disabled={!currentUser?.roles?.includes('Admin')}
                                        label={"Fecha Creación"}
                                        inputFormat="DD/MM/YYYY"
                                        value={(parseInt(params.fechaCreacion))}
                                        color={"secondary"}
                                        onChange={(v) => {
                                            handleChange('fechaCreacion', (new Date(v).setHours(23, 59, 0, 0)).valueOf())
                                        }}
                                        maxDate={dayjs().endOf('month')}
                                        renderInput={(params) => <TextField error={false}{...params} />}
                                    />
                                </LocalizationProvider>} sx={{ paddingLeft: '.5em', display: 'inline-flex', alingItems: 'strech' }} />
                                <Grid xs={3} children={<FormControlLabel label="Cochera" control={<Checkbox checked={params.cochera} disabled={!claseContrato?.principal} onChange={e => handleChange('cochera', e.target.checked)} />} sx={{ paddingLeft: '.5em' }} />} />
                                <Grid xs={3} children={<FormControlLabel label="Baulera" control={<Checkbox checked={params.baulera} disabled={!claseContrato?.principal} onChange={e => handleChange('baulera', e.target.checked)} />} sx={{ paddingLeft: '.5em' }} />} />
                                <Grid xs={3} sx={{ p: '1em' }} />
                                <Grid xs={4} children={<Typography children={`Prima ${parseInt(params.perPrimaAdjudicacion * 100)}%`} />} />
                                <Grid xs={8} children={<Slider style={{ zoom: 1 / scale }} value={params.perPrimaAdjudicacion} onChange={e => handleChange('perPrimaAdjudicacion', e.target.value)} valueLabelDisplay="auto" step={0.05} marks min={0} max={0.2} />} />
                                <Grid xs={6} children={<FormControlLabel label="Refuerzo Prorrateado" control={<Checkbox checked={!params.refuerzo} onChange={e => { handleChange('refuerzo', !e.target.checked); !e.target.checked ? setCampanas({ ...campanas, campana1: true }) : setCampanas({ ...campanas, campana1: false }) }} />} />} />
                                <Grid xs={6} children={<FormControlLabel label="Refuerzo Semestral" control={<Checkbox checked={params.refuerzo} onChange={e => { handleChange('refuerzo', e.target.checked); e.target.checked ? setCampanas({ ...campanas, campana1: true }) : setCampanas({ ...campanas, campana1: false }) }} />} />} />

                                <Grid xs={1.5} sx={{ p: '0em', marginTop: '1em' }} />
                                <Grid xs={3.5} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Nominal'} />
                                <Grid xs={2.5} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Bonif'} />
                                <Grid xs={3} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Reconocido'} />
                                <Grid xs={1.5} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Cuotas Eq'} />


                                <Grid xs={1.5} children={<Typography fontWeight={700} color={theme.palette.success.main} children="Adel. Inic." />} />
                                <Grid xs={3.5} children={<TextField type='number' InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" >
                                            <IconButton aria-label="toggle password visibility" onClick={() => handleChange('adelantoInicialNominal', 0.00)} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                                            </IconButton>
                                        </InputAdornment>),
                                    startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />)
                                }}
                                    value={params.adelantoInicialNominal} //Nom Original
                                    onChange={e => handleChange('adelantoInicialNominal', parseFloat(e.target.value))} />} />
                                <Grid xs={2.5} children={<TextField className='noBorder'
                                    margin="dense"
                                    InputProps={{
                                        style: getBonificacionInicial()?.nominal / 100 === 0 ?
                                            { fontWeight: "normal" } : { color: theme.palette.success.main, fontWeight: "bold" },
                                        readOnly: true,
                                        startAdornment: (<InputAdornment position="start" children={<AddIcon fontSize='small' />} />)
                                    }} value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((getBonificacionInicial().nominal / 100).toFixed(2)).replace("ARS", "")} //Nom Original
                                />} />
                                <Grid xs={3} children={<TextField className='noBorder'
                                    margin="dense"
                                    InputProps={{
                                        style: { color: theme.palette.secondary.dark, fontWeight: "bold" },
                                        readOnly: true,
                                        startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />)
                                    }} value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((getBonificacionInicial().nominal / 100 + params?.adelantoInicialNominal).toFixed(2)).replace("ARS", "")} //Nom Original
                                />} />
                                <Grid xs={1.5} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                    value={getConversionesCAC(nominal2CAC(params?.adelantoInicialNominal * 100 * (1 + claseContrato?.perBonificiacionAdelantoInicial), params.fechaCreacion), indice, { ...claseContrato, valorObjetoAhorroCAC: claseContrato?.valorObjetoAhorroCAC + (params?.cochera ? claseCochera?.valorObjetoAhorroCAC : 0) + (params?.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0) }).cuotasEq.toFixed(2)} />} />


                                <Grid xs={1.5} children={<Typography fontWeight={700} color={theme.palette.success.main} children="Aporte Pact." />} />
                                <Grid xs={3.5} children={<TextField htmlFor="standard-adornment-password" id="standard-adornment-password"
                                    helperText={cuotaPactadaNominal < getMinCuotaNominal() - 0.01 ? 'La cuota no podrá ser menor a $ ' + getMinCuotaNominal() : ''} error={cuotaPactadaNominal < getMinCuotaNominal() - 0.01 ? true : false} type="text" inputmode="numeric" sx={{ fontWeight: 600, }} InputProps={{
                                        inputProps: { min: getMinCuotaNominal() }, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />), endAdornment: (
                                            <InputAdornment position="end" ><IconButton aria-label="toggle password visibility" onClick={() => setCuotaPactadaNominal(parseFloat(getMinCuotaNominal()))} onMouseDown={(e) => handleMouseDownInput(e)} > <ReplayIcon />
                                            </IconButton></InputAdornment>)
                                    }} value={cuotaPactadaNominal} onChange={e => setCuotaPactadaNominal(parseFloat(e.target.value))} />} />
                                <Grid xs={2.5} children={<TextField className='noBorder'
                                    margin="dense"
                                    InputProps={{
                                        style: getAdelantoRecurrenteNom().toFixed(1) >= (bonificacionMensual().nominal / 100 + getAdelantoRecurrenteNom()).toFixed(1) ?
                                            { fontWeight: "normal" } : { color: theme.palette.success.main, fontWeight: "bold" },
                                        readOnly: true,
                                        startAdornment: (<InputAdornment position="start" children={<AddIcon fontSize='small' color={theme.palette.success.main} />} />)
                                    }}
                                    value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((bonificacionMensual().nominal / 100 > 0.00 ? bonificacionMensual().nominal / 100 : 0.00).toFixed(2)).replace("ARS", "")} //Nom Original
                                />} />
                                <Grid xs={3} children={<TextField className={'border'} multiline
                                    InputProps={{
                                        style: { color: theme.palette.secondary.dark, fontWeight: "bold" },
                                        readOnly: true,
                                        startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />)
                                    }}
                                    value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((aporteMensualReconocido().nominal / 100).toFixed(2)).replace("ARS", "")} //Nom Original
                                />} />
                                <Grid xs={1.5} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }} sx={{ fontWeight: 600 }}
                                    value={getConversionesCAC(nominal2CAC(cuotaPactadaNominal * 100 + getAdelantoRecurrenteNom() * 100 * claseContrato?.perBonificiacionAdelantoInicial, params.fechaCreacion), indice, { ...claseContrato, valorObjetoAhorroCAC: claseContrato?.valorObjetoAhorroCAC + (params?.cochera ? claseCochera?.valorObjetoAhorroCAC : 0) + (params?.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0) }).cuotasEq.toFixed(2)} />} />


                                <Grid xs={1.5} children={<Typography fontWeight={700} color={theme.palette.success.main} children="Adel. Recu." />} />
                                <Grid xs={3.5} children={<TextField type='string' className='noBorder' InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                    value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(getAdelantoRecurrenteNom().toFixed(2)).replace("ARS", "")} />} />
                                <Grid xs={2.5} />
                                <Grid xs={3} children={<TextField className='noBorder'
                                    margin="dense"
                                    InputProps={{
                                        style: { color: theme.palette.secondary.dark, fontWeight: "bold" },
                                        readOnly: true,
                                        startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' color={theme.palette.success.main} />} />)
                                    }}
                                    value={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((bonificacionMensual().nominal / 100 + getAdelantoRecurrenteNom()).toFixed(2) > 0.00 ? (bonificacionMensual().nominal / 100 + getAdelantoRecurrenteNom()).toFixed(2) : 0.00).replace("ARS", "")} //Nom Original
                                />} />
                                <Grid xs={1.5} children={<TextField type='number' className='noBorder' InputProps={{ readOnly: true }}
                                    value={getConversionesCAC(nominal2CAC(getAdelantoRecurrenteNom() * 100 * (1 + claseContrato?.perBonificiacionAdelantoInicial), params.fechaCreacion), indice, { ...claseContrato, valorObjetoAhorroCAC: claseContrato?.valorObjetoAhorroCAC + (params?.cochera ? claseCochera?.valorObjetoAhorroCAC : 0) + (params?.baulera ? claseBaulera?.valorObjetoAhorroCAC : 0) }).cuotasEq.toFixed(2)} />} />

                                <Grid xs={4} children={<FormControlLabel label="Segundo Aporte Mes n+1" control={<Checkbox checked={campanas?.campana2} onChange={e => setCampanas({ ...campanas, campana2: e.target.checked, campanaPAE: { ...campanas?.campanaPAE, fechaFinalizacion: !e.target.checked ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 4) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 3), fechaInicio: !e.target.checked ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 2) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 1) } })} />} sx={{ paddingLeft: '.5em' }} />} />
                                <Grid xs={4} children={<FormControlLabel label="Segundo Aporte Mes n+2" control={<Checkbox checked={!campanas?.campana2} onChange={e => setCampanas({ ...campanas, campana2: !e.target.checked, campanaPAE: { ...campanas?.campanaPAE, fechaFinalizacion: e.target.checked ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 4) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 3), fechaInicio: e.target.checked ? new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 2) : new Date(params?.fechaCreacion).setMonth(new Date(params?.fechaCreacion).getMonth() + 1) } })} />} sx={{ paddingLeft: '.5em' }} />} />
                                <Grid xs={4} children={<FormControlLabel label="Primer Refuerzo Mes n+3" control={<Checkbox checked={campanas?.campana1} disabled={!params?.refuerzo} onChange={e => setCampanas({ ...campanas, campana1: e.target.checked })} />} sx={{ paddingLeft: '.5em', paddingTop: '.5em' }} />} />
                                <Grid xs={campanas?.campanaPAE?.campanaPAE ? 2 : 12} key={'CampañaPAE'} children={<IconButton style={{ zoom: 1 / scale, marginBottom: '.4em', paddingLeft: 0 }} color={campanas?.campanaPAE?.campanaPAE ? 'primary' : 'secondary'} size={'large'} onClick={() => { setCampanas({ ...campanas, campanaPAE: { ...campanas?.campanaPAE, campanaPAE: !campanas?.campanaPAE?.campanaPAE } }); setModalCampPAE(!campanas?.campanaPAE?.campanaPAE && currentUser?.roles?.includes('Admin') ? true : false) }} children={<PopupIcon label={'Campaña ALTA TEMPRANA'} key={'CampañaPAE'} Icon={StarsIcon} />} />} />
                                {campanas?.campanaPAE?.campanaPAE ?
                                    <>
                                        {/* <Grid xs={3} children={<TextField sx={{ width: '100%' }}
                                            disabled={!(campanas.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                            value={campanas.campanaPAE?.porcentaje}
                                            onChange={(e) => { setCampanas({ ...campanas, campanaPAE: { ...campanas.campanaPAE, porcentaje: e.target.value } }) }}
                                            InputProps={{ inputProps: { min: 0, max: 100 } }}
                                            id="outlined-basic" type='number' label='%' defaultValue={0}
                                            error={campanas.campanaPAE?.porcentaje > 100 || campanas.campanaPAE?.porcentaje < 0}
                                        />} style={{ padding: '0.5rem' }} /> */}
                                        <Grid xs={5} children={<Typography sx={{ width: '100%' }}
                                            children={`Bonificación: $${new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((CAC2Nominal(getCuotaPAE()?.cac * (campanas.campanaPAE?.porcentaje / 100), params.fechaCreacion)) / 100).replace("ARS", "")}`}
                                        />} />
                                        {/* <Grid xs={2} children={<Typography sx={{ width: '100%' }}
                                            children={new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format((CAC2Nominal(getCuotaPAE()?.cac * (campanas.campanaPAE?.porcentaje / 100), params.fechaCreacion)) / 100).replace("ARS", "")}
                                            
                                        />} style={{ padding: '0.5rem' }} /> */}
                                        <Grid xs={5} children={<Typography sx={{ width: '100%' }}
                                            children={`Cuota Final: $${new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(cuotaPactadaNominal - ((CAC2Nominal(getCuotaPAE()?.cac * (campanas.campanaPAE?.porcentaje / 100), params.fechaCreacion)) / 100)).replace("ARS", "")}`}
                                        />} />
                                        {/* <Grid xs={3} children={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                disabled={!(campanas.campanaPAE?.campanaPAE || currentUser?.roles?.includes('Admin'))}
                                                label={"Fecha Fin"}
                                                inputFormat="DD/MM/YYYY"
                                                value={(parseInt(campanas.campanaPAE?.fechaFinalizacion))}
                                                color={"secondary"}
                                                onChange={(v) => { setCampanas({ ...campanas, campanaPAE: { ...campanas.campanaPAE, fechaFinalizacion: (new Date(v).setHours(23, 59, 0, 0)).valueOf() } }) }}
                                                renderInput={(params) => <TextField error={false}{...params} />} /></LocalizationProvider>} style={{ padding: '0.5rem' }} /> */}
                                    </> :
                                    null}

                                <Grid xs={4} children={<Typography fontWeight={700} color={theme.palette.success.main} children={`Adjudicación:`} />} />
                                <Grid xs={2} children={<FormControlLabel control={<Checkbox checked={simAdjudicacion} onChange={e => setSimAdjudicacion(e.target.checked)} />} />} />
                                <Grid xs={6} />
                                <Grid xs={6} children={<TipoAdjudicaciónSelector />} sx={{ paddingRight: '.5em' }} />
                                <Grid xs={6} children={<TextField type='number' label='Monto Oferta Dineraria' disabled={!simAdjudicacion || params.tipoAdjudicacion !== 'Dineraria'}
                                    InputProps={{ startAdornment: (<InputAdornment position="start" children={<AttachMoney fontSize='small' />} />) }}
                                    value={params.ofertaDineraria} onChange={e => handleChange('ofertaDineraria', e.target.value)} />} sx={{ paddingRight: '.5em' }} />
                                <Grid xs={12} sx={{ p: '.5em' }} />
                                <Grid xs={4} children={<Typography fontWeight={400} children={`Mes Adjudicación:`} />} />
                                <Grid xs={8} children={<Slider disabled={!simAdjudicacion} style={{ zoom: 1 / scale }} value={params.mesAdjudicacion} onChange={e => handleChange('mesAdjudicacion', e.target.value)} valueLabelDisplay="auto" step={1} min={0} max={240} />} />
                                <Grid xs={12} sx={{ p: '.5em' }} />
                                <Grid xs={4} children={<Typography fontWeight={400} children={`Meses Entregas:`} />} />
                                <Grid xs={8} children={<Slider disabled={!simAdjudicacion} style={{ zoom: 1 / scale }} value={params.mesesEntrega} onChange={e => handleChange('mesesEntrega', e.target.value)} valueLabelDisplay="auto" step={1} min={0} max={48} />} />

                            </Grid>} />
                            <Grid item xs={6} style={{ height: '100vh' }}>
                                <div style={{ height: '60vh', zoom: 1 / scale }} >
                                    <ResponsiveContainer width="100%" height="100%"  >
                                        <ComposedChart width={500} height={400} data={plotData} margin={{ top: 20, right: 0, bottom: 20, left: 0 }} >
                                            <CartesianGrid stroke="#f5f5f5" />
                                            <XAxis fontSize={12} domain={[0, 300]} interval={11} dataKey={v => v.i / 12} />
                                            <YAxis fontSize={12} yAxisId="GA" orientation='left' domain={[0, 1]} ticks={[0.2, 0.4, 0.6, 0.8, 1]} unit={'%'} tickFormatter={v => `${v * 100}`} />
                                            {/* <YAxis fontSize={12} yAxisId="puntos" orientation='right' unit={'p'} stroke={theme.palette.danger.main} /> */}
                                            <YAxis fontSize={12} domain={[0, 350]} yAxisId="capLicitatorio" orientation="right" ticks={[70, 140, 210, 280, 350]} unit={' C.Eq'} stroke={theme.palette.success.main} />
                                            <Tooltip fontSize={12} content={<CustomTooltip />} />
                                            <ReferenceArea y1={0.2} y2={0.8} yAxisId="GA" type="monotone" dataKey="a" fill={theme.palette.primary.main} />
                                            <Legend fontSize={12} />
                                            {[0.1999, 0.3999, 0.5999, 0.7999, .999].map(v => {
                                                const point = plotData.filter(d => d.GA >= v).sort((a, b) => a.GA - b.GA)[0];
                                                if (!point) return null;
                                                const x = point?.i / 12;
                                                const coord = { x, y: v }
                                                const str = `Año: ${parseInt(point.i / 12)}, Mes: ${point.i % 12 + 1}`
                                                return (<>
                                                    <ReferenceLine strokeDasharray="5 5" stroke="black" ifOverflow="extendDomain" key={`reference-line-horizontal-${v}`}
                                                        segment={[{ x: 0, y: coord.y }, coord]} yAxisId="GA" dataKey="GA"
                                                        label={{
                                                            value: str,
                                                            fontSize: 14,
                                                            position: "top"
                                                        }} />
                                                    <ReferenceLine strokeDasharray="5 5" stroke="black" ifOverflow="extendDomain" key={`reference-line-vertical-${v}`}
                                                        segment={[{ x: coord.x, y: 0 }, coord]} yAxisId="GA" dataKey="GA" />
                                                </>)
                                            })}

                                            <Line type="monotone" yAxisId="GA" dataKey="GA" strokeWidth={2} stroke={theme.palette.info.main} dot={false} activeDot={false} />
                                            <Line type="monotone" yAxisId="GA" dataKey="primaRestante" strokeWidth={2} stroke={theme.palette.warning.main} dot={false} activeDot={false} />
                                            <Line type="monotone" yAxisId="GA" dataKey="capLicitatorio" strokeWidth={2} stroke={theme.palette.success.main} dot={false} activeDot={false} />
                                            {simAdjudicacion ? <Scatter yAxisId="GA" dataKey="adjudicacion" fill={theme.palette.success.main} /> : null}
                                            {simAdjudicacion ? <Scatter yAxisId="GA" dataKey="entrega" fill={theme.palette.danger.main} /> : null}
                                        </ComposedChart>
                                    </ResponsiveContainer>
                                </div>
                                <CuotasTable />
                            </Grid>
                        </Grid>
                    </Fragment>
                    :
                    <Fragment>
                        <Grid container sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: "strech" }}>
                            <Box sx={{ width: '45%' }}>
                                <FormContainer onSuccess={handleSubmit}>
                                    <Grid xs={12} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Vendedor y Referido :'}>
                                    </Grid>
                                    <Grid conteiner sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: "strech" }}>
                                        <Grid xs={4} style={{ padding: '0.5rem', minWidth: '50%' }}>
                                            <Autocomplete
                                                name="referenciadoId"
                                                filterOptions={filterOptions}
                                                id="combo-box-demo"
                                                options={getDropdownVendedores(getDropdownOptions(true))}
                                                renderInput={(params) => <TextField {...params} label="Vendedor:" />}
                                                value={params?.vendedorId}
                                                onChange={(e, value) => {
                                                    let aux = { ...params }
                                                    aux.vendedorId = value
                                                    setParams(aux)
                                                }}
                                            />
                                        </Grid>
                                        <Grid xs={2} style={{ padding: '0.5rem', minWidth: '50%' }}>
                                            <Autocomplete
                                                filterOptions={filterOptions}
                                                id="combo-box-demo"
                                                options={getDropdownAhorristas(getDropdownOptions(true))}
                                                renderInput={(params) => <TextField {...params} label="Referido Por:" />}
                                                value={params?.referenciadoId}
                                                onChange={(e, value) => {
                                                    let aux = { ...params }
                                                    aux.referenciadoId = value
                                                    setParams(aux)

                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </FormContainer>
                                <Grid xs={12} sx={{ p: '0em', marginTop: '1em', paddingLeft: '.2em' }} fontWeight={600} backgroundColor={theme.palette.success.main} color='white' children={' Socios Titulares :'}>
                                </Grid>
                                <Fragment>

                                    {/* CREAR PERSONAS */}
                                    <TransitionGroup >
                                        {newSocios.map((newSocio, i) => {
                                            return (
                                                <Collapse key={`fragment-alta-pre-contrato-create-socio-${i}`}>
                                                    <FormContainer>
                                                        <Grid container spacing={2} style={{ padding: '0.5rem' }}>
                                                            <Typography xs={1} sx={{ paddingLeft: '.5em', marginTop: '1.5rem' }}>Nuevo socio {i + 1}</Typography>
                                                            <Grid xs={10} children={<FormControlLabel label="Persona Jurídica"
                                                                control={<Checkbox
                                                                    checked={newSocio.juridica}
                                                                    onChange={e => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i] = !(newSocio.juridica) ? formDfltsJuridica : formDflts;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />} sx={{ paddingLeft: '.5em', marginTop: '1rem' }} />} />
                                                            <Grid item xs={4} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                                                                <TextField sx={{ width: '100%' }} required label={newSocio.juridica ? 'Denominación Social' : 'Nombre (Obligatorio)'} name='nombre' value={newSocio.juridica ? newSocio.denominacionSocial : newSocio.nombre}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSocio.juridica ? newSociosAux[i].denominacionSocial = e.target.value : newSociosAux[i].nombre = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4} style={{ 'padding-top': '20px' }}> {/*el padding-top soluciona un problema con el label: se oculta cuando el usuario hace clicl. esto solo pasa para la primera fila de inputs*/}
                                                                <TextField sx={{ width: '100%' }} required label={newSocio.juridica ? 'Nombre Fantasía' : 'Apellido (Obligatorio)'} name='apellido' value={newSocio.juridica ? newSocio.nombreFantasia : newSocio.apellido}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSocio.juridica ? newSociosAux[i].nombreFantasia = e.target.value : newSociosAux[i].apellido = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4} style={{ 'padding-top': '20px' }}>
                                                                <TextField sx={{ width: '100%' }} required type='email' label='Email (Obligatorio)' name='email' value={newSocio.email}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].email = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextField sx={{ width: '100%' }} required label='Teléfono (Obligatorio)' type='number' name='telefono1' value={newSocio.telefono1}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].telefono1 = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TextFieldElement sx={{ width: '100%' }} required type='number' label='CUIT/CUIL (Obligatorio)' name='cuil'
                                                                    value={newSocio.cuil}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSocio.juridica ? newSociosAux[i].cuit = e.target.value : newSociosAux[i].cuit = e.target.value; newSociosAux[i].cuil = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <TextField sx={{ width: '100%' }}
                                                                    value={newSocio.porcentaje}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].porcentaje = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }}
                                                                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                                    id="outlined-basic" type='number' label='% Titularidad (Obligatorio)'
                                                                />
                                                            </Grid>
                                                            {newSocio.juridica ? null :
                                                                <>
                                                                    <Grid item xs={4}>
                                                                        <SelectElement
                                                                            sx={{ width: '100%' }}
                                                                            label="Tipo Documento"
                                                                            name="tipoDocumento"
                                                                            value={newSocio.tipoDocumento}
                                                                            options={[
                                                                                { id: TIPOS_DNI['dni'], label: TIPOS_DNI['dni'] },
                                                                                { id: TIPOS_DNI['pasaporte'], label: TIPOS_DNI['pasaporte'] },
                                                                                { id: TIPOS_DNI['libreta_enrolamiento'], label: TIPOS_DNI['libreta_enrolamiento'] },
                                                                                { id: TIPOS_DNI['libreta_civica'], label: TIPOS_DNI['libreta_civica'] },
                                                                            ]}
                                                                            onChange={(e) => {
                                                                                const newSociosAux = [...newSocios];
                                                                                newSociosAux[i].tipoDocumento = e;
                                                                                setNewSocios(newSociosAux)
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <TextFieldElement sx={{ width: '100%' }} required type='number' label='Número Documento' name='numeroDocumento'
                                                                            value={newSocio.numeroDocumento}
                                                                            onChange={(e) => {
                                                                                const newSociosAux = [...newSocios];
                                                                                newSociosAux[i].numeroDocumento = e.target.value;
                                                                                setNewSocios(newSociosAux)
                                                                            }} />
                                                                    </Grid></>}
                                                            <Grid item xs={4}>
                                                                <TextFieldElement sx={{ width: '100%' }} required label='País' name='pais'
                                                                    value={newSocio.pais}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].pais = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <TextFieldElement sx={{ width: '100%' }} required label='Provincia' name='provincia'
                                                                    value={newSocio.provincia}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].provincia = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <TextFieldElement sx={{ width: '100%' }} required label='Ciudad' name='ciudad'
                                                                    value={newSocio.ciudad}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].ciudad = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }} />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <TextField sx={{ width: '100%' }}
                                                                    value={newSocio.codigoPostal}
                                                                    onChange={(e) => {
                                                                        const newSociosAux = [...newSocios];
                                                                        newSociosAux[i].codigoPostal = e.target.value;
                                                                        setNewSocios(newSociosAux)
                                                                    }}
                                                                    InputProps={{ inputProps: { min: 0, max: 9999 } }}
                                                                    id="outlined-basic" type='number' label='Código Postal'
                                                                />
                                                            </Grid>
                                                            <Grid xs={2} style={{ padding: '0.5rem' }}>
                                                                <Button
                                                                    value={newSocio.titularPrincipal}
                                                                    onClick={() => {
                                                                        let newSociosAux = [...newSocios];
                                                                        newSociosAux = newSociosAux.map((sa, ia) => ia === i ? ({ ...sa, titularPrincipal: true }) : ({ ...sa, titularPrincipal: false }))
                                                                        setNewSocios(newSociosAux)
                                                                        let newSociosAux1 = [...socios];
                                                                        newSociosAux1 = newSociosAux1.map((sa) => ({ ...sa, titularPrincipal: false }))
                                                                        setSocios(newSociosAux1)
                                                                    }}
                                                                    color={newSocio.titularPrincipal ? 'primary' : 'secondary'}
                                                                    children={<><Typography children={'Titular Principal'} /><VerifiedIcon /></>}
                                                                />
                                                            </Grid>
                                                            <Grid xs={1} style={{ padding: '0.5rem', marginTop: "0.5rem" }}>
                                                                <IconButton className="mb-3" variant="contained" color='danger' onClick={_ => removeNewSocio(i)}><DeleteIcon /></IconButton>
                                                            </Grid>
                                                            <Divider></Divider>
                                                        </Grid>
                                                    </FormContainer>
                                                </Collapse>
                                            )
                                        })}
                                    </TransitionGroup >
                                    <Button onClick={() => setNewSocios([...newSocios, formDflts])}>Crear Ahorrista + </Button>
                                    {/* SELECCIONAR PERSONAS */}
                                    <TransitionGroup >
                                        {socios.map((socio, i) => {
                                            return (
                                                <Collapse key={`fragment-alta-pre-contrato-${i}`}>
                                                    <Grid container spacing={2} style={{ padding: '0.5rem', display: 'flex', alingItems: "strech" }}>
                                                        <Grid xs={6} style={{ padding: '0.5rem' }}>
                                                            <Autocomplete
                                                                id="combo-box-demo"
                                                                options={getDropdownOptions(true)}
                                                                renderInput={(params) => <TextField {...params} label="Socio" />}
                                                                onChange={(e, value) => { handelSocioChange(value, i) }}
                                                                value={socio.socio}
                                                            />
                                                        </Grid>
                                                        <Grid xs={3} style={{ padding: '0.5rem' }}>
                                                            <TextField
                                                                sx={{ display: 'flex', alingItems: "strech" }}
                                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                                value={socio.porcentaje}
                                                                onChange={(e) => {
                                                                    const newSociosAux = [...socios];
                                                                    newSociosAux[i].porcentaje = e.target.value;
                                                                    setSocios(newSociosAux)
                                                                }}
                                                                id="outlined-basic" type='number' label='%' defaultValue={0}
                                                            />
                                                        </Grid>
                                                        <Grid xs={2} style={{ padding: '0.5rem' }}>
                                                            <Button
                                                                value={socio.titularPrincipal}
                                                                onClick={() => {
                                                                    let newSociosAux1 = [...newSocios];
                                                                    newSociosAux1 = newSociosAux1.map(sa => ({ ...sa, titularPrincipal: false }))
                                                                    setNewSocios(newSociosAux1)
                                                                    let newSociosAux = [...socios];
                                                                    newSociosAux = newSociosAux.map((sa, ia) => ia === i ? ({ ...sa, titularPrincipal: true }) : ({ ...sa, titularPrincipal: false }))
                                                                    setSocios(newSociosAux)
                                                                }}
                                                                color={socio.titularPrincipal ? 'primary' : 'secondary'}
                                                                children={<><Typography children={'Titular Principal'} /><VerifiedIcon /></>}
                                                            />
                                                        </Grid>
                                                        <Grid xs={1} style={{ padding: '0.5rem', marginTop: "0.5rem" }}>
                                                            <IconButton className="mb-3" variant="contained" color='danger' onClick={_ => removeSocio(i)}><DeleteIcon /></IconButton>
                                                        </Grid>
                                                        <Divider></Divider>
                                                    </Grid>
                                                </Collapse>
                                            )
                                        })}
                                    </TransitionGroup >
                                    <Button onClick={() => setSocios([...socios, { socioId: null, porcentaje: 0, titularPrincipal: newSocios.concat(socios)?.length === 0 ? true : false, fechaAplicacionDesde: params?.fechaCreacion, fechaInicioVigencia: params?.fechaCreacion }])}>Seleccionar Ahorrista Existente +</Button>
                                    <Grid xs={12} style={{ padding: '0.5rem' }}>
                                        {msjFooter?.map((msj, i) => {
                                            return (
                                                <Typography color={theme.palette.danger.main} key={'MensajeErrorTitulares' + i}>{msj}</Typography>
                                            )
                                        })}
                                    </Grid>
                                </Fragment>
                            </Box >
                            {/* Minuta */}
                            <Box sx={{ width: '55%', overflowY: 'hidden' }}>
                                {loadingMinuta ? <div style={{ display: "flex", marginTop: "1.5em", marginLeft: "1em", }}> <div className="loading-screen" > Descargando PDF...</div> <ClipLoader
                                    sx={{ marginTop: "0.5em", marginLeft: "1.5em", }}
                                    color={theme.palette.success.main}
                                    loading={loadingMinuta}
                                    size={30}
                                    aria-label="Loading Minuta"
                                    data-testid="loader"
                                /> </div> : <Button
                                    sx={{ marginTop: "1em", marginLeft: "1em" }}
                                    onClick={() => {
                                        generatePDF("minuta-comercial").then(() => {
                                        }).catch((error) => { console.error('Error al generar el PDF:', error); });
                                    }}>Descargar Minuta<FileDownloadIcon />
                                </Button>}
                                <MinutaTabCotizador />
                            </Box>
                        </Grid>
                    </Fragment>
                }
            </Box>

        </Box>)
    };
    return (
        <>
            {
                fetching > 0 ?
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center', // Centra horizontalmente
                        alignItems: 'center', // Centra verticalmente
                        minHeight: '100vh', // Asegura que el contenedor ocupe toda la altura de la pantalla
                    }}>
                        <ClipLoader
                            color={theme.palette.success.main}
                            loading={fetching > 0}
                            size={30}
                            data-testid="loader"
                        />
                    </Box>
                    : 
                <ContratoForm />
            }
        </>
    )
};

export default CotizadorCat;

